import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex flex-col gap-2 max-w-2xl" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-4" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import type { TwoRowBentoGridProps } from "./bento.interfaces";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Card from "./two-row-bento-grid/card/Card.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TwoRowBentoGrid',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, { class: "max-w-2xl lg:max-w-7xl mx-auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.tag.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "tag"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        style: _normalizeStyle({ color: styleValues.value.brand }),
                        class: "font-semibold"
                      }, _toDisplayString(dataValues.value.tag.data.text), 5)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    "field-name": "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.title.data.text,
                        textColor: styleValues.value.text,
                        tag: dataValues.value.title.data.tag,
                        class: "mb-10 text-4xl md:mb-16 md:text-5xl"
                      }, null, 8, ["text", "textColor", "tag"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Card, {
                "field-prefix": "topLeftCard",
                blockId: _ctx.block.id,
                image: dataValues.value.topLeftCardImage,
                tag: dataValues.value.topLeftCardTag,
                title: dataValues.value.topLeftCardTitle,
                description: dataValues.value.topLeftCardDescription,
                tagTextColor: styleValues.value.brand,
                titleTextColor: styleValues.value.text,
                descriptionTextColor: styleValues.value.text,
                backgroundColor: styleValues.value.background,
                borderColor: styleValues.value.border,
                class: "rounded-b-lg rounded-t-3xl lg:rounded-lg lg:rounded-tl-3xl"
              }, null, 8, ["blockId", "image", "tag", "title", "description", "tagTextColor", "titleTextColor", "descriptionTextColor", "backgroundColor", "borderColor"]),
              _createVNode(Card, {
                "field-prefix": "topRightCard",
                blockId: _ctx.block.id,
                image: dataValues.value.topRightCardImage,
                tag: dataValues.value.topRightCardTag,
                title: dataValues.value.topRightCardTitle,
                description: dataValues.value.topRightCardDescription,
                tagTextColor: styleValues.value.brand,
                titleTextColor: styleValues.value.text,
                descriptionTextColor: styleValues.value.text,
                backgroundColor: styleValues.value.background,
                borderColor: styleValues.value.border,
                class: "rounded-lg lg:rounded-tr-3xl"
              }, null, 8, ["blockId", "image", "tag", "title", "description", "tagTextColor", "titleTextColor", "descriptionTextColor", "backgroundColor", "borderColor"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Card, {
                "field-prefix": "bottomLeftCard",
                blockId: _ctx.block.id,
                image: dataValues.value.bottomLeftCardImage,
                tag: dataValues.value.bottomLeftCardTag,
                title: dataValues.value.bottomLeftCardTitle,
                description: dataValues.value.bottomLeftCardDescription,
                tagTextColor: styleValues.value.brand,
                titleTextColor: styleValues.value.text,
                descriptionTextColor: styleValues.value.text,
                backgroundColor: styleValues.value.background,
                borderColor: styleValues.value.border,
                class: "rounded-lg lg:rounded-bl-3xl"
              }, null, 8, ["blockId", "image", "tag", "title", "description", "tagTextColor", "titleTextColor", "descriptionTextColor", "backgroundColor", "borderColor"]),
              _createVNode(Card, {
                "field-prefix": "bottomCenterCard",
                blockId: _ctx.block.id,
                image: dataValues.value.bottomCenterCardImage,
                tag: dataValues.value.bottomCenterCardTag,
                title: dataValues.value.bottomCenterCardTitle,
                description: dataValues.value.bottomCenterCardDescription,
                tagTextColor: styleValues.value.brand,
                titleTextColor: styleValues.value.text,
                descriptionTextColor: styleValues.value.text,
                backgroundColor: styleValues.value.background,
                borderColor: styleValues.value.border,
                class: "rounded-lg"
              }, null, 8, ["blockId", "image", "tag", "title", "description", "tagTextColor", "titleTextColor", "descriptionTextColor", "backgroundColor", "borderColor"]),
              _createVNode(Card, {
                "field-prefix": "bottomRightCard",
                blockId: _ctx.block.id,
                image: dataValues.value.bottomRightCardImage,
                tag: dataValues.value.bottomRightCardTag,
                title: dataValues.value.bottomRightCardTitle,
                description: dataValues.value.bottomRightCardDescription,
                tagTextColor: styleValues.value.brand,
                titleTextColor: styleValues.value.text,
                descriptionTextColor: styleValues.value.text,
                backgroundColor: styleValues.value.background,
                borderColor: styleValues.value.border,
                class: "rounded-t-lg rounded-b-3xl lg:rounded-lg lg:rounded-br-3xl"
              }, null, 8, ["blockId", "image", "tag", "title", "description", "tagTextColor", "titleTextColor", "descriptionTextColor", "backgroundColor", "borderColor"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})